import React from "react";
import SkeletonLoader from "shrimmer/SkeletonLoader";

const CmsContentShrimmer = () => {
  return <SkeletonLoader type={"text"} height={20} count={14.8} width={1200} />;
};

export default CmsContentShrimmer;
